import { Currency } from "../common";
import { InitializationStep } from "../Users";

export class AuthToken {
	token = "";

	constructor(token: string) {
		this.token = token;
	}
}

export class Auth0LoginState {
	signup_initiating_vendor?: string;
	sample_data_company_id?: string;
	open_signup_video?: boolean;
	parent_account?: string;
	no_of_additional_users?: number;
	addon_id?: string;
	plan_id?: string;
	tr_code?: string;
	coupon?: string;
	login_hint?: string;
	return_to_url?: string;
}

export class LoginRequest {
	email: string;
	password: string;
	for_customer: boolean;
	partner_id: string | null;

	constructor(
		email: string,
		password: string,
		for_customer = false,
		partner_id: string | null = null
	) {
		this.email = email;
		this.for_customer = for_customer;
		this.partner_id = partner_id;
		this.password = password;
	}
}

export class LoginFormValues {
	email = "";
	password = "";
	remember = false;
}

export class SignupRequest {
	email = "";
	full_name = "";
	plan_id?: string | null;
	tr_code?: string | null;
	coupon?: string | null;
	parent_account?: string | null;
	no_of_additional_users?: number | null;
	campaign_id?: string | null;
	signup_document_type_selected?: string | null;
	currency?: string | null;

	constructor(
		email: string,
		full_name: string,
		plan_id?: string | null,
		tr_code?: string | null,
		coupon?: string | null,
		parent_account?: string | null,
		no_of_additional_users?: number | null,
		campaign_id?: string | null,
		signup_document_type_selected?: string | null,
		currency?: string | null
	) {
		this.email = email;
		this.full_name = full_name;
		this.plan_id = plan_id;
		this.tr_code = tr_code;
		this.coupon = coupon;
		this.parent_account = parent_account;
		this.no_of_additional_users = no_of_additional_users;
		this.campaign_id = campaign_id;
		this.signup_document_type_selected = signup_document_type_selected;
		if (currency) {
			this.currency = currency;
		}
	}
}

export enum NoOfUsersRange {
	ONE = "one",
	TWO_TO_FIVE = "two_to_five",
	FIVE_TO_FIFTEEN = "five_to_fifteen",
	FIFTEEN_PLUS = "fifteen_plus"
}

export class UserCompanyConfigUpdateRequest {
	full_name?: string;
	phone?: string;
	company_name?: string;
	domain?: string;
	currency?: Currency;
	locale?: string;
	time_zone_offset?: number;
	psa?: string;
	company_initialization_step?: InitializationStep;
	signup_initiating_vendor?: string | null;
	sample_data_company_id?: string | null;
	no_of_users_range?: NoOfUsersRange;
}

export class UserCompanyConfigFormValues {
	company_name = "";
	domain = "";
	currency: Currency = Currency.USD;
	psa?: string;
}

export class SignupWithEmailValues {
	email = "";
	full_name = "";
}

export class ResendEmailVerificationRequest {
	email = "";

	constructor(email = "") {
		this.email = email;
	}
}

export class EmailVerificationResponse {
	message = "";
}
